/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Ocop_LevelInputs */

const vi_shop_home_ocop_level = /** @type {(inputs: Shop_Home_Ocop_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấp`)
};

/**

* @param {Shop_Home_Ocop_LevelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_ocop_level = /** @type {((inputs?: Shop_Home_Ocop_LevelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Ocop_LevelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_ocop_level(inputs)
});